import React from "react";
import SectionContainer from "../../../components/sectionContainer/sectionContainer";
import { actionCreators } from "./redux/marketingSagas";
import IntroRevenue from "./smartComponents/introRevenue";
import IntrosSold from "./smartComponents/introsSold";
import ProfilesCreated from "./smartComponents/profilesCreated";
import ProfilesToFirstVisit from "./smartComponents/profilesToFirstVisit";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { useSelector } from "react-redux";
import { useFetchData } from "../hooks/dataFetchingHooks";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";

const MarketingModule = (props) => {
  useFetchData({
    moduleName: "marketing",
    props,
    fetchData: actionCreators.fetchCurrentUser,
    updateData: actionCreators.updateAllData
  });

  const isLoading = useSelector((state) => state.marketing.isLoading);

  return (
    <SectionToggle
      title="Marketing"
      learnMore={
        <KBLearnMore
          title="Marketing"
          description="This report provides an overview of your marketing performance, including intros sold, profiles created, and conversions. These insights help you evaluate which marketing efforts drive the strongest results and where adjustments may be needed."
          kbUrl={ILEARN_URLS.dashboard.marketing}
        />
      }
      isLoading={isLoading}
      height={350}
      content={
        <div id="marketingModule">
          <div className="section-group">
            <div className="width-50" style={{ width: "50%", height: "140px" }}>
              <SectionContainer title="Intro Revenue">
                <IntroRevenue />
              </SectionContainer>
            </div>
            <div className="width-50" style={{ width: "50%", height: "140px" }}>
              <SectionContainer title="Intros Sold">
                <IntrosSold />
              </SectionContainer>
            </div>
          </div>
          <div className="section-group">
            <div>
              <div className="width-50" style={{ width: "50%", height: "140px" }}>
                <SectionContainer title="Profiles Created">
                  <ProfilesCreated />
                </SectionContainer>
              </div>
              <div className="width-50" style={{ width: "50%", height: "140px" }}>
                <SectionContainer title="Profiles to First Visit">
                  <ProfilesToFirstVisit />
                </SectionContainer>
              </div>
            </div>
          </div>
          <div className="clear-fix" />
        </div>
      }
    />
  );
};

export default MarketingModule;
